<template>

    <modal :show="showModal" @close="closeModal">

        <div class="p-3">

            <h2 class="text-center mb-4">Choose your plan</h2>

            <div class="h-100 overflow-y-auto">
                <component
                    v-for="bill in sortedBills"
                    :key="bill.id"
                    :is="cardType(group)"
                    :bill="bill"
                    :bills="sortedBills"
                    :housemates="housemates"
                    :selected="isBillSelected(bill.id)"
                    @toggle="toggleBill($event)">
                </component>
            </div>

        </div>

    </modal>

</template>

<script>
import store from "../../../store";
import Modal from "../../Modal";
import BillCardEnergy from "./BillCardEnergy";
import BillCardInternet from "./BillCardInternet";
import BillCardTvPackage from "./BillCardTvPackage";
import BillCardStandard from "./BillCardStandard";

export default {
    name: "BillCompareModal",

    components: {
        Modal,
        BillCardEnergy,
        BillCardInternet,
        BillCardTvPackage,
        BillCardStandard,
    },

    props: {
        housemates: {
            type: Number,
            required: true,
        },
    },

    methods: {
        closeModal() {
            store.commit("quote/hideBillCompareModal");
        },

        toggleBill(id) {
            let selected = this.$store.getters["quote/getBillSelected"](id);

            if (selected) {
                // Remove bill if it is selected
                store.commit("quote/deselectBill", id);
            } else {
                // Remove any other selected bills within the same group
                store.dispatch("quote/deselectGroup", this.group.id);
                store.commit("quote/selectBill", id);
                this.closeModal();
            }
        },

        isBillSelected(id) {
            return this.$store.getters["quote/getBillSelected"](id);
        },

        cardType(group) {
            switch (group.name) {
                case "Renewable Energy":
                    return "BillCardEnergy";
                case "Internet":
                    return "BillCardInternet";
                case "TV Package":
                    return "BillCardTvPackage";
                default:
                    return "BillCardStandard";
            }
        },
    },

    computed: {
        sortedBills() {
            if (!this.group) return [];
            if (this.group.name === "Internet") {
                return _.orderBy(this.group.bills, "provider_id", "desc");
            } else {
                return _.orderBy(this.group.bills, "id", "asc");
            }
        },

        showModal() {
            return this.$store.getters["quote/getShowBillCompareModal"];
        },

        group() {
            return this.$store.getters["quote/getActiveBillCompareGroup"];
        },
    },
};
</script>
